import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=efafcb2e&"
import script from "./SearchComponent.vue?vue&type=script&lang=ts&"
export * from "./SearchComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports